module.exports = __webpack_public_path__ + "media/Components/fonts/boldOleoScript-9f2a6e398434ad4fb383aa9d00d675e7.ttf";